import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M17.5 15.833c0 .92-.736 1.667-1.644 1.667H4.144A1.655 1.655 0 0 1 2.5 15.833v-2.5c0-.92.736-1.666 1.644-1.666h11.712c.908 0 1.644.746 1.644 1.666zM17.5 4.167c0-.92-.736-1.667-1.644-1.667H4.144c-.908 0-1.644.746-1.644 1.667v2.5c0 .92.736 1.666 1.644 1.666h11.712c.908 0 1.644-.746 1.644-1.666z"
    }, null, -1)
  ]))]))
}
export default { render: render }